// components/ScorePickerModal.js
import React from 'react';
import {
  View,
  Text,
  TouchableOpacity,
  Modal,
  StyleSheet
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import hapticService from '../services/hapticService';

const ScorePickerModal = ({ 
  visible, 
  currentValue, 
  position, 
  onSelect, 
  onCancel 
}) => {
  const pointValues = [0, 10, 20, 30, 40, 50, 60, '-'];

  const handleValueSelect = (value) => {
    hapticService.score();
    onSelect(value);
  };

  const handleClear = () => {
    hapticService.button();
    onSelect('-');
  };

  const handleCancel = () => {
    hapticService.button();
    onCancel();
  };

  return (
    <Modal
      visible={visible}
      transparent={true}
      animationType="fade"
      onRequestClose={handleCancel}
    >
      <View style={styles.overlay}>
        <View style={styles.modalContainer}>
          <View style={styles.header}>
            <Text style={styles.title}>
              Select Score for {position}
            </Text>
            <TouchableOpacity onPress={handleCancel} style={styles.closeButton}>
              <Ionicons name="close" size={24} color="#666" />
            </TouchableOpacity>
          </View>
          
          <View style={styles.pointsGrid}>
            {pointValues.map(value => (
              <TouchableOpacity
                key={value}
                style={[
                  styles.pointButton,
                  value === '-' && styles.notScoredButton,
                  currentValue === value.toString() && styles.currentValueButton
                ]}
                onPress={() => handleValueSelect(value.toString())}
              >
                <Text style={[
                  styles.pointButtonText,
                  value === '-' && styles.notScoredButtonText,
                  currentValue === value.toString() && styles.currentValueButtonText
                ]}>
                  {value}
                </Text>
              </TouchableOpacity>
            ))}
          </View>
          
          <View style={styles.footer}>
            <View style={styles.currentValueInfo}>
              <Text style={styles.currentLabel}>Current: </Text>
              <Text style={[
                styles.currentValue,
                currentValue === '-' && styles.currentValueEmpty
              ]}>
                {currentValue || '-'}
              </Text>
            </View>
            
            <View style={styles.actionButtons}>
              <TouchableOpacity
                style={styles.clearButton}
                onPress={handleClear}
              >
                <Text style={styles.clearButtonText}>Clear</Text>
              </TouchableOpacity>
              
              <TouchableOpacity
                style={styles.cancelButton}
                onPress={handleCancel}
              >
                <Text style={styles.cancelButtonText}>Cancel</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  modalContainer: {
    backgroundColor: '#fff',
    borderRadius: 16,
    padding: 24,
    maxWidth: 400,
    width: '100%',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.3,
    shadowRadius: 8,
    elevation: 8,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 24,
  },
  title: {
    fontSize: 18,
    
    color: '#333',
    fontFamily: 'Montserrat_700Bold',
    flex: 1,
  },
  closeButton: {
    padding: 4,
  },
  pointsGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: 12,
    marginBottom: 24,
  },
  pointButton: {
    backgroundColor: '#f0f0f0',
    borderRadius: 12,
    width: 60,
    height: 60,
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 2,
    borderColor: '#e0e0e0',
  },
  notScoredButton: {
    backgroundColor: '#f5f5f5',
    borderColor: '#999999',
  },
  currentValueButton: {
    backgroundColor: '#0066cc',
    borderColor: '#0066cc',
  },
  pointButtonText: {
    fontSize: 20,
    
    color: '#555',
    fontFamily: 'Montserrat_700Bold',
  },
  notScoredButtonText: {
    color: '#999999',
  },
  currentValueButtonText: {
    color: '#fff',
  },
  footer: {
    borderTopWidth: 1,
    borderTopColor: '#e0e0e0',
    paddingTop: 16,
  },
  currentValueInfo: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 16,
  },
  currentLabel: {
    fontSize: 16,
    color: '#666',
    fontFamily: 'Montserrat_500Medium',
  },
  currentValue: {
    fontSize: 18,
    
    color: '#333',
    fontFamily: 'Montserrat_700Bold',
  },
  currentValueEmpty: {
    color: '#999999',
  },
  actionButtons: {
    flexDirection: 'row',
    justifyContent: 'center',
    gap: 12,
  },
  clearButton: {
    backgroundColor: '#ff9800',
    borderRadius: 8,
    paddingVertical: 10,
    paddingHorizontal: 20,
  },
  clearButtonText: {
    color: '#fff',
    fontSize: 14,
    
    fontFamily: 'Montserrat_600SemiBold',
  },
  cancelButton: {
    backgroundColor: '#6c757d',
    borderRadius: 8,
    paddingVertical: 10,
    paddingHorizontal: 20,
  },
  cancelButtonText: {
    color: '#fff',
    fontSize: 14,
    
    fontFamily: 'Montserrat_600SemiBold',
  },
});

export default ScorePickerModal;